import { render, staticRenderFns } from "./UserMessageWindow.vue?vue&type=template&id=79365cb2&scoped=true&"
import script from "./UserMessageWindow.vue?vue&type=script&lang=js&"
export * from "./UserMessageWindow.vue?vue&type=script&lang=js&"
import style0 from "./UserMessageWindow.vue?vue&type=style&index=0&id=79365cb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79365cb2",
  null
  
)

export default component.exports